module.exports = __webpack_public_path__ + "static/media/allinone.b9902b7d.svg";